import type { Moment } from 'moment';

/**
 * Maximum number of days allowed between start and end of any frontend-driven
 * date-range filter sent to the backend. Both DateRangePicker (MasterFilter) and
 * DatePickerWithShortcuts hard-block selections wider than this. The saas_back
 * `dateRangeLimit` middleware mirrors the same limit as defense-in-depth.
 */
export const MAX_RANGE_DAYS = 90;

/** Days between start and end (inclusive). Returns 0 when either bound is missing. */
export const rangeDays = (start: Moment | null, end: Moment | null): number => {
  if (!start || !end) return 0;
  return Math.abs(end.diff(start, 'days')) + 1;
};

/** Returns true when range exceeds `maxDays` (defaults to MAX_RANGE_DAYS). */
export const isRangeTooWide = (start: Moment | null, end: Moment | null, maxDays: number = MAX_RANGE_DAYS): boolean => {
  if (!start || !end) return false;
  return rangeDays(start, end) > maxDays;
};

/** Human-readable max message with a custom limit. */
export const maxRangeMessage = (maxDays: number = MAX_RANGE_DAYS): string =>
  `El rango máximo permitido es de ${maxDays} días.`;
